import React, { useState, useContext } from 'react'

import { Button } from 'src/components/shared'
import { CommentsContext } from './util'

// New comment text field component
const AddComment = ({ parentId, closeText }) => {
  const [comment, setComment] = useState('')
  const context = useContext(CommentsContext)
  const { collectionId, postComment } = context

  const onCommentInput = ({ target }) => {
    setComment(target.value)
  }

  const onClick = () => onCommentPost(collectionId, comment)

  const onCommentPost = (collectionId, comment) => {
    if (!collectionId) return
    closeText()

    const payload = {
      comment,
      collection_id: collectionId,
      reveal: true,
      parent_id: null,
    }
    if (!!parentId) payload.parent_id = parentId

    postComment({ collectionId, payload })
  }

  return (
    <div className="comments-form">
      <textarea
        className={`form-control`}
        rows={2}
        placeholder={'Commenting anonymously'}
        value={comment}
        onChange={onCommentInput}
      ></textarea>
      <Button
        sm
        primary
        submit
        className="float-right"
        disabled={!comment || comment.trim().length === 0}
        onClick={onClick}
      >
        Add comment
      </Button>
    </div>
  )
}

export default AddComment
